export default __webpack_public_path__ + "static/media/SPACE_FOR_A_BETTER_WORLD.a9c92915.jpg";